module.exports = __webpack_public_path__ + "img/image18.45215c98.png";